/**
 * Animals that are one animal.
 *
 * Everything in `wildlife.js` is a species: rolled, met, gone, and the next one
 * is a different one. A row here is a single animal that lives in one place,
 * that you meet more than once, and that remembers what you did the first
 * time. There is one, and nothing else in the desert remembers anything.
 *
 *   kind     what it is, from the catalogue
 *   lies     where it lies, in feet: its place, which it goes back to
 *   meets    feet: a golf cart you are driving this close is meeting it
 *   leaves   feet: that far away again, and the meeting is over
 *   aim      feet: a cart whose line would pass this close was coming at it.
 *            It moves, every time, and nothing ever touches it; what is kept
 *            is that you came at it
 *   says     what the screen says the next time you meet it, by what you did
 *            the first time. It says it is the same animal, and why
 */
export const INDIVIDUALS = [
  {
    id: 'cart-path-rattler',
    kind: 'rattlesnake',
    name: 'the rattlesnake on the cart road',
    // Lying across the cart road on the warm asphalt, where the road runs
    // south past the mouth of the wash: the line every golf cart to the
    // Caytons takes.
    lies: [-160, 22],
    meets: 24,
    leaves: 60,
    aim: 3,
    says: {
      strikes: 'The same rattlesnake from the cart road. You drove at it last time, and it has not forgotten.',
      lets: 'The same rattlesnake from the cart road. You went round it last time, and it lets you by.',
    },
  },
];

export default INDIVIDUALS;
